<template>
<v-app>
    <Header :table_name="table_name" :table_type="table_type" :table_detail="table_detail" />
    <Buffet :typeMenu="typeMenuBuffet" />
    <Advertise :pictureAdvertise="picture_advertise" v-if="open_advertise" />
    <Footer :table_type="table_type" />
</v-app>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import Header from '@/components/menuuser/Header.vue'
import Buffet from '@/components/menuuser/Buffet.vue'
import Advertise from '@/components/menuuser/Advertise.vue'
import Footer from '@/components/menuuser/Footer.vue'
export default {
    name: 'buffetUser',
    components: {
        Header,
        Buffet,
        Advertise,
        Footer,
    },
    data() {
        return {
            typeMenuBuffet: this.$store.state.tab_menu == null ? 'buffet' : this.$store.state.tab_menu,
            table_name: '',
            table_type: '',
            table_detail: '',
            open_advertise: false,
            picture_advertise: null,
        }
    },
    methods: {
        // async changeTypeMenu(typeMenu) {
        //     this.typeMenuBuffet = typeMenu
        // },
        async tableDetail() {
            HTTP.get(`/customer/open-buffet/` + this.$route.params.id  + `/` + this.$route.params.pre_order + `?store_id=${this.$route.query.store_id}&token=`+this.$route.params.token, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        if (response.data.opentable_detail.type !== 'บุฟเฟ่') {
                            this.$router.push('/singledishmealuser/' + this.$route.params.id + '/' + this.$route.params.token)
                        }
                        this.table_name = response.data.opentable_detail.name
                        this.table_type = response.data.opentable_detail.type
                        this.table_detail = response.data.opentable_detail.detail
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        // this.$router.push('/thankyouuser')
                    }

                })
        }
    },
    created() {
        HTTP.get(`/POS/table/check_token_opentable/` + this.$route.params.id + `/` + this.$route.params.token+ `/` + this.$route.params.pre_order, {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
            .then((response) => {
                if (response.data.successful === false) {
                    this.$store.commit('clearCartListUser')
                    this.$store.commit('clearCartTakeOutTableListUser')
                    this.$store.commit('clearCartListUserTakeOut')
                    this.$store.commit('clearCartOrderOnlineUser')
                    this.$router.push('/thankyouuser')
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
                if (error.response.status === 500) {
                    this.$store.commit('clearCartListUser')
                    this.$store.commit('clearCartTakeOutTableListUser')
                    this.$store.commit('clearCartListUserTakeOut')
                    this.$store.commit('clearCartOrderOnlineUser')
                    this.$router.push('/thankyouuser')
                }

            })
    },
    mounted() {
        this.tableDetail()
        HTTP.get(`/advertiseuser` + `?store_id=${this.$route.query.store_id}&token=`+this.$route.params.token, {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
            .then((response) => {
                if (response.data.successful === true) {
                    this.picture_advertise = response.data.detail[0].picture
                    const dateTodayList = new Date();
                    const date_month = dateTodayList.getMonth() + 1
                    const date_today = dateTodayList.getFullYear() + '-' + date_month + '-' + dateTodayList.getDate()
                    if (this.$store.state.checkAdvertiseDate != date_today || this.$store.state.checkAdvertiseType != 'buffet') {
                        const data = {
                            date:date_today,
                            type:'buffet'
                        }
                        this.$store.commit('startAdvertise',data)
                    }

                    this.open_advertise = false
                    if (response.data.detail[0].status === 1 && this.$store.state.checkAdvertise) {
                        this.open_advertise = true
                    }
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
    }
}
</script>
